"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessSpinner = void 0;
const react_1 = __importDefault(require("react"));
const ProcessSpinner = () => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", style: {
        margin: 'auto',
        background: 'none',
        WebkitAnimationPlayState: 'running',
        animationPlayState: 'running',
        WebkitAnimationDelay: '0s',
        animationDelay: '0s'
    }, width: "85", height: "85", display: "block", preserveAspectRatio: "xMidYMid", viewBox: "0 0 100 100" },
    react_1.default.createElement("circle", { cx: "50", cy: "50", r: "44", fill: "none", stroke: "#00b0f0", strokeDasharray: "207.34511513692632 71.11503837897544", strokeWidth: "5", style: {
            WebkitAnimationPlayState: 'running',
            animationPlayState: 'running',
            WebkitAnimationDelay: '0s',
            animationDelay: '0s'
        }, transform: "rotate(91.65 50 50)" },
        react_1.default.createElement("animateTransform", { attributeName: "transform", dur: "1.1904761904761905s", keyTimes: "0;1", repeatCount: "indefinite", type: "rotate", values: "0 50 50;360 50 50" }))));
exports.ProcessSpinner = ProcessSpinner;
